var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mp__settings"},[_c('div',{staticClass:"nav"},[_c('router-link',{staticClass:"personal",attrs:{"to":"/settings/personal"}},[_c('Person'),_c('p',[_vm._v("Mi información")])],1)],1),_c('div',{staticClass:"tab"},[_c('RouterView',{attrs:{"user":_vm.user}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }